module.exports = __webpack_public_path__ + "static/media/Rec_alpha_black_portrait.f1c6b1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Rec_alpha_black_portrait.png
// module id = 1087
// module chunks = 0